export interface ListPageToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  /** Result-count line (already translated). */
  countText: string;
  actionLabel: string;
  onAction: () => void;
}

/**
 * Desktop toolbar for list pages without a full filter bar
 * (Roles, Organizations): search input, result count, primary action.
 * Rendered via ListPageLayout's `desktopToolbar` slot.
 */
export const ListPageToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  countText,
  actionLabel,
  onAction,
}: ListPageToolbarProps) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1.5rem',
      gap: '1rem',
      flexWrap: 'wrap',
    }}
  >
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flex: 1 }}>
      <input
        type="text"
        className="filter-search-input"
        placeholder={searchPlaceholder}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        aria-label={searchPlaceholder}
        style={{ maxWidth: 320 }}
      />
      <p className="stations-count" style={{ margin: 0 }}>
        {countText}
      </p>
    </div>
    <button type="button" className="primary-action-btn" onClick={onAction}>
      <span className="material-symbols-outlined" aria-hidden="true">
        add
      </span>
      {actionLabel}
    </button>
  </div>
);

export default ListPageToolbar;
